import { rankWith, scopeEndsWith } from '@jsonforms/core';
import RootTagControl from './component';

export const RootTagTester = rankWith(10, scopeEndsWith('scan_root'));

export default RootTagControl;
